import { Button } from 'antd';
import { Link } from 'react-router-dom';
import Lottie from 'react-lottie';
import notFoundAnimation from '../components/assets/lottie/not-found-animation.json';

const NotFound = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: notFoundAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center space-y-8">
      <div className="w-80 h-80">
        <Lottie options={defaultOptions} />
      </div>
      <h2 className="text-4xl font-bold text-gray-800">Oops! Page not found</h2>
      <p className="text-lg text-gray-600">
        It seems you've hit a dead end. The page you're looking for doesn't
        exist or has moved.
      </p>
      <Link to="/">
        <Button type="primary" size="large" className="mt-6">
          Go Back to Home
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
